"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildRoomModel = exports.STEPPER_EVENTS = exports.PASSENGER_TYPE = exports.MAX_ROOM_COUNT = void 0;
var PASSENGER_TYPE = {
  ADULT: 'adult',
  CHILD: 'child',
  INFANT: 'infant'
};
exports.PASSENGER_TYPE = PASSENGER_TYPE;
var MAX_ROOM_COUNT = 3;
exports.MAX_ROOM_COUNT = MAX_ROOM_COUNT;

var buildRoomModel = function buildRoomModel() {
  var adult = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var child = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var infant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return {
    adult: adult,
    child: child,
    infant: infant
  };
};

exports.buildRoomModel = buildRoomModel;
var STEPPER_EVENTS = {
  INCREMENT: 'inc',
  DECREMENT: 'DEC'
};
exports.STEPPER_EVENTS = STEPPER_EVENTS;